import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import creativeData from '../../data/creativeData.json';

const Services = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  return (
    <section className="section-lg">
      <Container className="py-5">
        <div className="service-heading mb-3">
          <motion.h6 className="underline-after text-center position-relative z-0"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="position-relative z-1 bg-white text-primary px-3">OUR SERVICES</span>
          </motion.h6>
          <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Creative Solutions For Your Business
          </motion.h2>
        </div>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4">
            {creativeData.services.map((service) => (
              <Col md={6} lg={4} key={service.id}>
                <motion.div
                  variants={cardVariants}
                  whileHover={{ y: -10, transition: { duration: 0.3 } }}
                >
                  <Card className="h-100 transition-all text-center hover-shadow transition">
                    <Card.Body className="text-center">
                      <div className="d-flex justify-content-center align-items-center mb-4">
                        <motion.div className={`icon-wrapper bg-${service.variant}-subtle border border-${service.variant}`}
                          whileHover={{ rotate: 360, scale: 1.1 }}
                          transition={{ duration: 0.5 }}
                        >
                          <i className={`${service.icon} text-${service.variant} fs-2`}></i>
                        </motion.div>
                      </div>
                      <h4 className="fw-semibold mb-3">{service.title}</h4>
                      <p className="text-secondary mb-4">{service.description}</p>
                      <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                        <Button variant={`outline-${service.variant}`} size="sm" className="rounded-pill px-3">Learn More</Button>
                      </motion.div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Services;
